import React, { FC } from 'react';
import { PrivacyWrapper } from './style';
import Container from '@/Components/atoms/Container';
import { useTranslation } from 'next-i18next';
import PublicLayout from '@/Components/layouts/ResponsivePublicLayout';
import AnimatedBackTitle from '@/Components/atoms/AnimatedBackTitle';

interface IFaqpageProps {};

const PrivacyPage: FC<IFaqpageProps> = () => {
  const { t } = useTranslation(['privacy']);

  return (
    <PrivacyWrapper>
      <AnimatedBackTitle title={t('privacy:title')} />
      <br />
      <br />
      <Container>
        <div dangerouslySetInnerHTML={{ __html: t('privacy:html_content') as string }} />
      </Container>
    </PrivacyWrapper>
  )
}

export default function PRIVACY_PAGE () {

  return (
    <PublicLayout>
      <PrivacyPage/>
    </PublicLayout>
  )
};
